import styled from 'styled-components';
import { AppStyledProps } from '../../../../../types';

type T = AppStyledProps;

export const ContentStyled = styled.div<T>`
  display: flex;
  justify-content: center;
  align-items: start;
  padding: 3em 10em;

  ${({ theme }) =>
    theme.device.mobile &&
    `
      padding: 1em 6em;
  `}
`;
